import {tva} from "@gluestack-ui/nativewind-utils/tva";
import type {AccountType} from "@hosttools/core/constant";
import {VStack} from "@hosttools/frontend";
import type React from "react";
import {memo} from "react";

import ChannelSelection from "@/client/components/ModalAddAccount/ChannelSelection";
import Text from "@/client/components/Text";

export type ConnectedChannels = Partial<Record<AccountType, number>>;

type Props = {
    channels: readonly AccountType[];
    connectedChannels?: ConnectedChannels;
    disconnectedChannels?: ConnectedChannels;
    hideSocial?: boolean;
    onSelectChannel: (channel: AccountType) => void;
};

const channelWrapperStyle = tva({
    base: "",
    variants: {
        hideSocial: {
            true: "md:flex-row"
        }
    }
});

const Channels: React.FC<Props> = ({
    channels,
    connectedChannels = {},
    disconnectedChannels = {},
    hideSocial,
    onSelectChannel
}) => {
    return (
        <VStack space="lg">
            {hideSocial ? (
                <Text className="sm:mt-4 md:mt-0" variant="md">
                    Choose a channel list
                </Text>
            ) : (
                <VStack space="sm">
                    <Text className="sm:block md:hidden" variant="2xl">
                        Connect Account
                    </Text>
                    <Text variant="sm">
                        Host Tool links with channels like Airbnb, Booking.com, and VRBO to automate
                        the management of your listing.
                    </Text>
                    <Text variant="sm">
                        Please select the channels you would like to link with Host Tools.
                    </Text>
                </VStack>
            )}
            <VStack className={channelWrapperStyle({hideSocial})} space="lg">
                {channels.map(channel => (
                    <ChannelSelection
                        key={channel}
                        channel={channel}
                        connectedChannels={connectedChannels}
                        disconnectedChannels={disconnectedChannels}
                        hideSocial={hideSocial}
                        onSelectChannel={onSelectChannel}
                    />
                ))}
            </VStack>
        </VStack>
    );
};

export default memo(Channels);
